<script lang="ts" setup>
import type { ProductOfferDto } from '@/ts/types/insurance.dto.ts'
import { translate } from '@/i18n/i18n.ts'
import { LIcon } from '@wgg.hyve/hyve-ui-library'
import Divider from '@/components/atom/divider/Divider.vue'
import { computed } from 'vue'

type Props = {
  modalData: ProductOfferDto
}

const props = defineProps<Props>()
const { content, documents } = props.modalData

const advantages = computed(() => {
  return content?.advantages
})

const openDocument = (url: string) => {
  window.open(url, '_blank')
}
</script>

<template>
  <div class="modal__your-tariff">
    <p
      class="modal__your-tariff__p--no-margin modal__text"
      v-html="translate('modal_content.your_tariff.paragraph_1')"
    ></p>

    <ul>
      <li v-for="(advantage, index) in advantages" :key="`advantage-${index}`">
        <div class="list-wrapper list-wrapper__advantages">
          <LIcon class="list-wrapper__advantages__icon" icon="lnx-check_circle" />
          <span class="modal__text">{{ advantage.body }}</span>
        </div>
      </li>
    </ul>

    <Divider />

    <h6 class="h6">Kleingedrucktes zum Mitnehmen</h6>

    <ul>
      <li
        v-for="(doc, index) in documents"
        :key="`document-${index}`"
        @click="openDocument(doc.link)"
      >
        <div class="list-wrapper list-wrapper__documents">
          <LIcon class="list-wrapper__documents__icon" icon="lnx-download" />
          <a :href="doc.link" class="modal__text" target="_blank">{{ doc.title }}</a>
        </div>
      </li>
    </ul>
  </div>
</template>

<style lang="scss" scoped>
@import 'your-tariff-modal';
</style>
